export default __webpack_public_path__ + "static/media/product-image-6.7fccde9c.jpg";